<template>
  <div class='animated fadeIn'>
    <b-row v-if="$route.name === 'Contractors'">
      <b-col lg='12'>
          <h4 class="card-title"><b>Contractors</b> List</h4>
          <b-row class="mt-4">
            <b-col lg='4' md='6'>
              <b-form-group
                label="Name"
                label-for="visitType"
                :label-cols="3"
                :horizontal="true">
                <text-input-del-btn
                  id="exampleInput2"
                  type="text"
                  v-model="filterBy.search"
                  placeholder="">
                </text-input-del-btn>
              </b-form-group>
            </b-col>
            <b-col lg='2' md='2'>
              <b-button variant="success" class="btn-rounded mb-3" @click="doFilter()">
                <i class="fa fa-search"></i>
              </b-button>
            </b-col> 
            <b-col lg='6' md='4' class="text-right">
              <b-button href="#/settings/user/contractors/create" size="lg" class="btn-rounded mb-3" variant="success">
                <i class="fa fa-plus"></i>
              </b-button>
            </b-col>
          </b-row>

          <c-server-table
            :url="apiUrl"
            :urlRemove="apiUrlDelete"
            :columns="columns"
            :options="options"
            :method_1="openStatusReasonModal"
            ref="dataTable">
          </c-server-table>

      </b-col><!--/.col-->
    </b-row><!--/.row-->
    <b-modal ref="statusReasonModal" hide-footer title="Reason Change Status">
      <b-form v-on:submit.prevent="doUpdateStatus">
        <b-alert :show="statusReason.hasError !== false" variant="danger"><i class="fa fa-exclamation" aria-hidden="true"></i> {{statusReason.hasError}}</b-alert>
        <b-form-group
              label="Reason" label-for="note"
              label-class="font-weight-bold"
              label-cols="3" :horizontal="true">
          <b-form-textarea id="textarea1" v-model="statusReason.note" placeholder="Reason" :rows="3" :max-rows="6"></b-form-textarea><span class="required-input-sign">*</span>
        </b-form-group>
      <b-button
            type="submit"
            size="md"
            variant="primary"
            class="btn-pill pull-right">
          <i v-if="!statusReason.showLoader" class="fa fa-plus"/><i v-else class="fa fa-spinner fa-spin fa-fw"/> Submit
        </b-button>
      </b-form>
    </b-modal>
    <router-view></router-view>
  </div>
</template>

<script>
import axios from 'axios'
import cServerTable from '@/views/components/cServerTable'
import TextInputDelBtn from '@/views/components/forms/TextInputDelBtn'

export default {
  name: 'tenantIndex',
  components: {
    cServerTable,
    TextInputDelBtn
  },
  data () {
    // table config
    let config = cServerTable.methods.setTableConfig({
      columns: [
        'firstName',
        'phone',
        // 'address',
        // 'locationGroup',
        // 'unit',
        'isActive',
        'actionButtons'
      ],
      options: {
        headings: {
          firstName: 'Name',
          phone: 'Phone',
          address: 'Address',
          locationGroup: 'Location Group',
          unit: 'Unit',
          isActive: 'Status',
          actionButtons: ''
        },
        uniqueKey: 'uuid',
        params: {
          search: this.$route.query.search,
          address: this.$route.query.address,
          role: 'contractor',
          parent: null,
          location_group_uuid: this.$route.query.location_group_uuid
        },
        templates: {
          firstName (h, row) {
            return row.firstName + ' ' + (window.setDefaultNull(row.lastName, ''))
          },
          locationGroup (h, row) {
            return row.locationGroup === null ? '-' : row.locationGroup.name
          }
        },
        sortable: ['firstName', 'isActive'],
        groupBy: 'parent',
        groupMeta: []
      }
    }, 'profile')

    // data returned
    return {
      apiUrl: window.AppConfig.apiUrl + 'profile',
      apiUrlDelete: window.AppConfig.apiUrl + 'tenant',
      apiUrlUpdateStatus: window.AppConfig.apiUrl + 'user-activated',
      apiUrlLocationGroupList: window.AppConfig.apiUrl + 'location-group',
      // vue-table-2 config
      columns: config.columns,
      options: config.options,
      // filter var
      filterBy: {
        locationGroupList: [],
        search: window.setDefaultNull(this.$route.query.search),
        address: window.setDefaultNull(this.$route.query.address),
        filterLocationGroup: window.setDefaultNull(this.$route.query.location_group_uuid)
      },
      statusReason: {
        hasError: false,
        row: null,
        note: null,
        showLoader: false
      }
    }
  },
  mounted () {
    this.initDropdownOptions_Group()
  },
  methods: {
    initDropdownOptions_Group () {
      axios.get(this.apiUrlLocationGroupList)
        .then(response => {
          if (response !== undefined) {
            let datas = response.data._embedded.locationGroup
            for (let i = 0; i < response.data.total_items; i++) {
              this.filterBy.locationGroupList.push({text: datas[i].name, value: datas[i].uuid})
            }
          }
        })
        .catch(function (error) {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
        }) // .bind(this)
    },
    doFilter () {
      this.options.params.location_group_uuid = window.setDefaultNull(this.filterBy.filterLocationGroup)
      this.options.params.search = this.filterBy.search === '' ? null : this.filterBy.search
      this.options.params.address = this.filterBy.address === '' ? null : this.filterBy.address
      this.$refs.dataTable.setTableDatas()
    },
    openStatusReasonModal (row) {
      this.statusReason.showLoader = false
      this.statusReason.hasError = false
      this.statusReason.row = row
      this.statusReason.note = null
      this.$refs.statusReasonModal.show()
    },
    doUpdateStatus () {
      if (!this.statusReason.showLoader) {
        if (this.statusReason.note !== '' && this.statusReason.note !== null) {
          this.statusReason.hasError = false
          this.statusReason.showLoader = true
          let data = {
            uuid: this.statusReason.row.uuid,
            note: this.statusReason.note,
            isActive: !this.statusReason.row.isActive ? 1 : 0
          }
          axios.post(this.apiUrlUpdateStatus, data)
            .then(response => {
              this.statusReason.row.isActive = data.isActive ? 1 : 0
              this.statusReason.showLoader = false
              this.statusReason.hasError = false
              this.statusReason.row = null
              this.statusReason.note = null
              this.$refs.statusReasonModal.hide()
            })
            .catch(error => {
              window.consoleLog(error)
              this.statusReason.showLoader = false
              this.statusReason.hasError = error
            })
        } else {
          this.statusReason.showLoader = false
          this.statusReason.hasError = 'Please complete all required fields'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/settings/tenant/Index.vue